// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"ModalButtons_buttonsContainer__OYcFt","buttons":"ModalButtons_buttons__-d1Mb"};